var Quiz = new Vue({
    el: '.resources .quiz.vue',
    data: {
        results: [],
        answers: {},
        quizData: {},
        palettes: [],
        slider: null,
        page: 'start',
        previousPage: ''
    },
    mounted() {
        $( '.resources .quiz.vue .content.hidden' ).removeClass( 'hidden' );
        const _this = this;
        this.getQuizData().then(data => {
            _this.quizData = data;
        });

        this.fetchPalettes().then(data => {
            _this.palettes = data;
        });

        if ( localStorage.getItem( 'quiz-answers' ) ) {
            this.answers = JSON.parse( localStorage.getItem( 'quiz-answers' ) );
        }

        this.page = window.location.pathname.split('/').filter(Boolean).pop();
        this.page = 'quiz' === this.page ? 'start' : this.page;

        if ( window.location.pathname.includes('/pages/quiz/results') ) {
            const results = JSON.parse( localStorage.getItem( 'quiz-results' ) ) || [];
            if ( results.length > 0 ) {
                this.results = results;                
                setTimeout(() => {
                    _this.initSlider();
                }, 1);
            }
            setTimeout(() => {
                const $current = $( `.block[data-ref="results"]` );
                setTimeout( function() {
                    $current.attr( 'data-transform', '1' );
                }, 450 );
                $current.attr( 'data-visibility', '1' );
            }, 1);
        }
        this.renderProgressbar();
    },
    computed: {
        utils() {
            return Utils || {};
        },
        questions() {
            let items = {
                'rooms': {
                    'question': 'Which room are you decorating?',
                    'options': [ 'Living Room', 'Kitchen', 'Dining Room', 'Bedroom', 'Bathroom', 'Halfway' ]
                },
                'lights': {
                    'question': 'When does the sunlight reach this room?',
                    'options': [ 'All Day', 'Morning', 'Afternoon', 'Never' ]
                },
                'moods': {
                    'question': 'Which mood are you looking for?',
                    'options': [ 'Relaxing', 'Cosy', 'Moody', 'Airy', 'Energising' ]
                },
                'colours': {
                    'question': 'Do you have colour tones in mind yet?',
                    'options': [ 'Yes', 'No' ]
                },
                'tones': {
                    'question': 'Please select up to three colour tones.',
                    'options': [ 'Whites', 'Beiges', 'Yellows', 'Reds', 'Pinks', 'Purples', 'Blues', 'Greens' ]
                }
            };
            if (Object.keys(this.quizData).length === 0) {
                return items;
            }
            for (const key in items) {
                if ( 'colours' == key ) {
                    continue;
                }
                let options = [...new Set(
                    this.quizData.flatMap(item => {
                        const val = 'tones' == key ? item.tone : item[key];
                        if (Array.isArray(val)) {
                            return val;
                        } else if (typeof val === 'string') {
                            try {
                                const arr = JSON.parse(val);
                                if (Array.isArray(arr)) return arr;
                            } catch (e) {}
                        }
                        return val;
                    })
                )];
                const order = items[key].options;
                const ordered = order.filter(item => options.includes(item));
                const extras = options.filter(item => !order.includes(item));
                items[key].options = [...ordered, ...extras];
            }
            return items;
        },
        resultTitle() {
            return this.results.length > 0 ? `<span>Here's some palettes for</span> <span>your ${this.answers.moods.toLowerCase()} ${this.answers.rooms.toLowerCase()}.</span>` : 'Sorry, we couldn\'t find any paint palettes matching your choices. Please try again with different options.';
        },
        index() {
            const _this = this;
            if ( this.page === 'start' ) {
                return 0;
            }
            if ( this.page === 'results' ) {
                return 6;
            }
            const keys = Object.keys(this.questions);
            let index = keys.findIndex(item => item == _this.page);
            return index + 1;
        }
    },
    methods: {
        getQuizData() {
            return fetch(window.quizUrl)
                .then(response => response.json())
                .catch(error => {
                    console.error('Error fetching quiz info:', error);
                    return [];
                });
        },
        fetchPalettes() {
            return fetch(window.palettesURL)                
                .then(response => response.json())
                .catch(error => {
                    console.error('Error fetching colours:', error);
                    return [];
                });
        },
        navigate(key) {
            if ( this.page === 'start' ) {
                this.answers = {};
                localStorage.removeItem( 'quiz-answers' );
                localStorage.removeItem( 'quiz-results' );
                this.results = [];
                if ( this.slider ) {
                    this.slider.destroy( true, true );
                    this.slider = null;
                }
            }

            const $current = $( `.block[data-ref="${this.page}"]` );
            const $next = $( `.block[data-ref="${key}"]` );
            
            $current.attr( 'data-transform', '3' );
            setTimeout( function() {
                $next.attr( 'data-transform', '1' );
            }, 450 );
            $next.attr( 'data-visibility', '1' );
            setTimeout( function() {
                $current.attr( 'data-visibility', '0' );
            }, 600 );

            this.page = key;
            history.pushState({}, '', `/pages/quiz/${key}`);

            if ( 'results' == key ) {
                this.showResults();                
            }
            this.renderProgressbar();
        },
        setAnswers(key, value, evt) {
            const _this = this;
            if ( 'tones' == key ) {
                const $option = $(`.resources .quiz .questions [data-ref="tones"] .tones [data-tone="${this.utils.hyphenate(value)}"]`);
                if ( ! ( key in this.answers ) ) {
                    this.answers[ key ] = [];
                }
                if ( ! this.answers[ key ].includes( value ) ) {
                    if ( this.answers[ key ].length >= 3 ) {
                        return;
                    }
                    this.answers[ key ].push( value );
                    $option.attr( 'data-action', 1 );
                }  else {
                    this.answers[ key ] = this.answers[ key ].filter(v => v !== value);
                    $option.attr( 'data-action', 0 );
                }
                this.saveAnswers();
                return;
            }

            if ( 'colours' == key && 'No' == value ) {
                this.answers[ 'tones' ] = [];
                this.saveAnswers();
                this.navigate( 'results' );
                return;
            }

            this.answers[ key ] = value;
            this.saveAnswers();

            const keys = Object.keys(this.questions);
            let index = keys.findIndex(item => item == _this.page);
            const _key = keys[index + 1] || 'results';
            this.navigate( _key );
        },
        saveAnswers() {
            localStorage.setItem( 'quiz-answers', JSON.stringify( this.answers ) );
        },
        showResults() {
            const _this = this;
            let items = [];
            const data = this.quizData;
            const answers = this.answers;
            const palettes = JSON.parse( JSON.stringify( this.palettes ) );
            if ( data.length === 0 || palettes.length === 0 || Object.keys( answers ).length === 0 ) {
                this.results = [];
            }                         
            items = data.filter(item => {
                for (const key in answers) {
                    if (key === 'colours') {
                        continue;
                    }
                    if (key === 'tones') {
                        if (Array.isArray(answers[key]) && answers[key].length > 0) {
                            if (!answers[key].includes(item.tone)) {
                                return false;
                            }
                        }
                        continue;
                    }                    
                    let itemValue = item[key];
                    let itemArray = null;
                    try {
                        itemArray = JSON.parse(itemValue);
                    } catch (e) {
                        itemArray = null;
                    }
                    if (itemArray && Array.isArray(itemArray)) {
                        if (!itemArray.includes(answers[key])) {
                            return false;
                        }
                    } else {
                        if (itemValue !== answers[key]) {
                            return false;
                        }
                    }
                }
                return true;
            });
            items = JSON.parse( JSON.stringify( items ) );
            items.forEach( item => {
                    let palette = palettes.find( palette => palette.colour.id === item.product.id );
                    let selectedPalette = palette ? (palette.complementary || palette.tonal) : null;
                    if (selectedPalette && Array.isArray(selectedPalette.items)) {
                        selectedPalette.items = selectedPalette.items.slice(0, 3);
                    }
                    item.palettes = selectedPalette.items;
            });
            this.results = items;
            if ( this.results.length > 0 ) {
                setTimeout(() => {
                    _this.initSlider();
                    const $current = $( `.block[data-ref="results"]` );
                    setTimeout( function() {
                        $current.attr( 'data-transform', '1' );
                    }, 450 );
                    $current.attr( 'data-visibility', '1' );
                }, 1); 
            }
            localStorage.setItem( 'quiz-results', JSON.stringify( this.results ) );
        },
        initSlider() {
            if ( ! this.slider ) {
                this.slider = new Swiper( '.resources .quiz .slider', {
                    containerModifierClass: 'slide-',
                    slideActiveClass: 'active',
                    slideBlankClass: 'blank',
                    slideClass: 'slide',
                    slideNextClass: 'next',
                    slidePrevClass: 'previous',
                    slideVisibleClass: 'visible',
                    wrapperClass: 'slides',
                    centerInsufficientSlides: true,
                    simulateTouch: true,
                    touchRatio: 1,
                    navigation: {
                        disabledClass: 'disabled',
                        nextEl: '.resources .quiz .buttons .next',
                        prevEl: '.resources .quiz .buttons .previous',
                    },
                    breakpoints: {
                        0: {
                            speed: 625,                    
                            spaceBetween: 12,
                            slidesPerView: 1.35,
                        },
                        600: {
                            speed: 625,                    
                            spaceBetween: 18,
                            slidesPerView: 2,
                        },
                        750: {
                            speed: 625,                    
                            spaceBetween: 18,
                            slidesPerView: 3,
                        },                
                        900: {
                            speed: 750,                    
                            spaceBetween: 20,
                            slidesPerView: 3,
                        },
                        1250: {
                            speed: 750,                    
                            spaceBetween: 20,
                            slidesPerView: 4,
                        }                                
                    }
                }); 
            } else {
                this.slider.update();
            }
        },
        back(e) {        
            const _this = this;
            const keys = Object.keys(this.questions);
            let index = keys.findIndex(item => item == _this.page);
            const previousPage = keys[index - 1] || keys[keys.length - 1];
            this.navigate(previousPage);
        },
        isVisible(page) {
            return this.page === page;
        },
        renderProgressbar() {
            $( '.resources .quiz .content .sections .section.two .blocks .block .lines' ).attr( 'data-lines', this.index );
        },
        renderCounter() {
            const total = Object.keys(this.questions).filter(item => item != 'tones').length + 1;
            let index = this.index;
            if ( this.page == 'tones' ) {
                index = 4;
            } else if ( this.page == 'results' ) {
                index = 5;
            }
            return `<div class="text">Step ${index} / ${total}</div>`;
        }
    }
});